import React, { useEffect } from "react";
import LetsTalkButton from "../components/LetsTalkButton";

import "../styles/Home.css";

export default function HeroSection() {
  useEffect(() => {
    document.title = "Home | Inypeople";
  }, []);

  return (
    <>
      {/* HERO SECTION */}
      <div className="hero-container">
        <div className="hero-content">
          <div className="content-wrapper">
            <h1 className="hero-title">
              Transforming{" "}
              <span className="title-highlight">
                Industries Through Innovative
              </span>{" "}
              Product Design & Development Serving Businesses{" "}
              <span className="title-underlined">Across All Industries</span>
            </h1>

            <p className="hero-subtitle">
              Develop.Deploy.Thrive. Partner with us
            </p>

            {/* Feature Cards with Dotted Lines */}
            <div className="feature-section">
              <div className="dotted-line-horizontal"></div>

              <div className="dotted-line-vertical left"></div>
              <div className="dotted-line-vertical right"></div>
              <div className="dotted-line-vertical bottom-left"></div>
              <div className="dotted-line-vertical bottom-right"></div>

              <svg
                className="zigzag-dotted-line"
                width="870"
                height="165"
                viewBox="0 0 870 150"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <polyline
                  points="
      
      185,40
      240,120
      750,120
    "
                  stroke="#3b82f6"
                  strokeWidth="2"
                  strokeDasharray="6 6 "
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>

              <svg
                width="845"
                height="345"
                viewBox="0 0 500 350"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="dotted-connector"
              >
                <path
                  d="
      M 60 220
      
      L 260 220
      L 330 115
    "
                  stroke="#3b82f6"
                  strokeWidth="2"
                  strokeDasharray="7 7"
                  strokeLinecap="round"
                  fill="none"
                  strokeLinejoin="round"
                />
              </svg>

              {/* Top Row Cards */}
              <div className="feature-cards-top">
                <div className="feature-card-1">
                  <img
                    src={process.env.PUBLIC_URL + "/assets/icons/icon_1.png"}
                    alt="Get to Market Faster"
                    className="card-icon"
                  />
                  <h3 className="card-title">Get to Market Faster</h3>
                </div>

                <div className="feature-card-2">
                  <img
                    src={process.env.PUBLIC_URL + "/assets/icons/icon_2.png"}
                    alt="Building Trust"
                    className="card-icon"
                  />
                  <h3 className="card-title">Building Trust</h3>
                </div>

                <div className="feature-card-3">
                  <img
                    src={process.env.PUBLIC_URL + "/assets/icons/icon_3.png"}
                    alt="Ensuring Confidentiality"
                    className="card-icon"
                  />
                  <h3 className="card-title">Ensuring Confidentiality</h3>
                </div>
              </div>

              {/* Bottom Row Cards */}
              <div className="feature-cards-bottom">
                <div className="feature-card-4">
                  <img
                    src={process.env.PUBLIC_URL + "/assets/icons/icon_4.png"}
                    alt="Delivering Quality"
                    className="card-icon"
                  />
                  <h3 className="card-title">Delivering Quality</h3>
                </div>

                <div className="feature-card-5">
                  <img
                    src={process.env.PUBLIC_URL + "/assets/icons/icon_5.png"}
                    alt="Maintaining Consistency"
                    className="card-icon"
                  />
                  <h3 className="card-title">Maintaining Consistency</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* TRUSTED PARTNERS SECTION */}
      <section className="trusted-partners-section">
        <h2 className="partners-title">
          Trusted by the World's Top Partners to{" "}
          <span className="partners-highlight">Fuel Business Expansion</span>
        </h2>

        <div className="partners-grid">
          {/* First 5 logos */}
          <div className="partners-group group-1">
            <div className="partner-logo">
              <img
                src={process.env.PUBLIC_URL + "/assets/logo/trust_1.png"}
                alt="NOVAC"
                className="partner-logo-img"
              />
            </div>
            <div className="partner-logo">
              <img
                src={process.env.PUBLIC_URL + "/assets/logo/atos_1.png"}
                alt="atos"
                className="partner-logo-img"
              />
            </div>
            <div className="partner-logo">
              <img
                src={process.env.PUBLIC_URL + "/assets/logo/trust_2.png"}
                alt="TVS"
                className="partner-logo-img"
              />
            </div>
            <div className="partner-logo">
              <img
                src={process.env.PUBLIC_URL + "/assets/logo/trust_3.png"}
                alt="RELEVANT"
                className="partner-logo-img"
              />
            </div>
            <div className="partner-logo">
              <img
                src={process.env.PUBLIC_URL + "/assets/logo/trust_4.png"}
                alt="PRODAPT"
                className="partner-logo-img"
              />
            </div>
            <div className="partner-logo">
              <img
                src={process.env.PUBLIC_URL + "/assets/logo/trust_5.png"}
                alt="IRIS"
                className="partner-logo-img"
              />
            </div>
          </div>

          {/* Next 6 logos */}
          <div className="partners-group group-2">
            <div className="partner-logo">
              <img
                src={process.env.PUBLIC_URL + "/assets/logo/trust_6.png"}
                alt="RCH"
                className="partner-logo-img"
              />
            </div>
            <div className="partner-logo">
              <img
                src={process.env.PUBLIC_URL + "/assets/logo/neu.png"}
                alt="RCH"
                className="partner-logo-img"
              />
            </div>

            <div className="partner-logo">
              <img
                src={process.env.PUBLIC_URL + "/assets/logo/trust_7.png"}
                alt="PROCHANT"
                className="partner-logo-img"
              />
            </div>
            <div className="partner-logo">
              <img
                src={process.env.PUBLIC_URL + "/assets/logo/trust_8.png"}
                alt="inspirisys"
                className="partner-logo-img"
              />
            </div>
            <div className="partner-logo">
              <img
                src={process.env.PUBLIC_URL + "/assets/logo/trust_9.png"}
                alt="CONTUS"
                className="partner-logo-img"
              />
            </div>
            <div className="partner-logo">
              <img
                src={process.env.PUBLIC_URL + "/assets/logo/trust_10.png"}
                alt="COLAN"
                className="partner-logo-img"
              />
            </div>
            <div className="partner-logo">
              <img
                src={process.env.PUBLIC_URL + "/assets/logo/trust_11.png"}
                alt="KARTECH"
                className="partner-logo-img kartech-logo"
              />
            </div>
            
          </div>

          {/* Last 6 logos */}
          <div className="partners-group group-3">
            <div className="partner-logo">
              <img
                src={process.env.PUBLIC_URL + "/assets/logo/trust_12.png"}
                alt="SMARTECH"
                className="partner-logo-img"
              />
            </div>
             <div className="partner-logo">
              <img
                src={process.env.PUBLIC_URL + "/assets/logo/finzly.png"}
                alt="SMARTECH"
                className="partner-logo-img"
              />
            </div>
            <div className="partner-logo">
              <img
                src={process.env.PUBLIC_URL + "/assets/logo/trust_13.png"}
                alt="SINSIPLE"
                className="partner-logo-img"
              />
            </div>
            <div className="partner-logo">
              <img
                src={process.env.PUBLIC_URL + "/assets/logo/trust_14.png"}
                alt="EDEVEON"
                className="partner-logo-img"
              />
            </div>
            <div className="partner-logo small-logo">
              <img
                src={process.env.PUBLIC_URL + "/assets/logo/trust_15.png"}
                alt="FLATRIONS"
                className="partner-logo-img"
              />
            </div>
            <div className="partner-logo small-logo">
              <img
                src={process.env.PUBLIC_URL + "/assets/logo/trust_16.png"}
                alt="INFINITI"
                className="partner-logo-img"
              />
            </div>
            <div className="partner-logo">
              <img
                src={process.env.PUBLIC_URL + "/assets/logo/trust_17.png"}
                alt="KANINI"
                className="partner-logo-img"
              />
            </div>
            <div className="partner-logo small-logo">
              <img
                src={process.env.PUBLIC_URL + "/assets/logo/vir.png"}
                alt="INFINITI"
                className="partner-logo-img"
              />
            </div>
          </div>
        </div>
      </section>
      {/* WHY CHOOSE INYPEOPLE */}
      <section className="why-section">
        <div className="why-container">
          <h2 className="why-title">
            Why Choose Inypeople, Top Reasons to Partner With Us
          </h2>

          <div className="why-grid">
            {/* Card 1 */}
            <div className="why-card">
              <div className="why-header">
                <span className="why-number">01</span>
                <h3 className="why-card-title title-left">
                  Expert Solutions & Proven Experience
                </h3>
              </div>
              <p className="why-description">
                Our team of seasoned experts brings deep technical knowledge and
                strong industry insights to every engagement. We combine
                experience with execution to deliver measurable outcomes.
              </p>
            </div>

            {/* Card 2 */}
            <div className="why-card">
              <div className="why-header">
                <span className="why-number">02</span>
                <h3 className="why-card-title title-down">
                  Client-Centric Approach
                </h3>
              </div>
              <p className="why-description_2">
                Our clients are at the core of everything we do. We collaborate
                closely to understand your challenges, align with your goals,
                and deliver solutions that create real impact and long-term
                success.
              </p>
            </div>

            {/* Card 3 */}
            <div className="why-card">
              <div className="why-header_3">
                <span className="why-number">03</span>
                <h3 className="why-card-title title-down">
                  Transforming Businesses Through Technology
                </h3>
              </div>
              <p className="why-description_3">
                We embrace innovation and leverage the latest technologies to
                build scalable, future-ready products and services that keep
                your organization ahead of the curve.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* NEXT SECTION - Text Left, Image Right */}
      <section className="next-section">
        <div className="next-section-container">
          {/* Left Text */}
          <div className="next-text">
            <h2 className="next-title">
              Empowering Businesses Through{" "}
              <span className="highlight">Digital Innovation</span>
            </h2>
            <p className="next-description">
              At Inypeople, we deliver unmatched expertise, exceptional quality,
              and a truly client-centric approach. Our innovative solutions
              harness the latest technologies to help you stay ahead in a
              rapidly evolving digital landscape. From strategic IT staffing to
              cutting-edge software development, we partner with you to build
              scalable solutions that drive growth, efficiency, and long-term
              success.
            </p>
          </div>

          {/* Right Image */}
          {/* Right Image */}
          <div className="next-image">
            <img
              src={process.env.PUBLIC_URL + "/assets/images/empower.jpg"}
              alt="Team working on laptop"
            />
          </div>
        </div>
      </section>
      {/* SERVICES SECTION */}
      <section className=" home-services-section">
        <div className="home-services-container">
          <h2 className="home-services-title">
            Transforming Businesses{" "}
            <span className="home-services-highlight">Through Our Services</span>
          </h2>

          <div className="home-services-grid">
            {/* Service Card 1 */}
            <div className="home-service-card-wrapper"> 
            <div className="home-service-card1">
              <div className="home-service-icon-wrapper">
                <div className="home-service-icon">
                  <img
                    src={
                      process.env.PUBLIC_URL + "/assets/icons/trans_icon_1.png"
                    }
                    alt="transicon1"
                    className="home-service-icon-img"
                  />
                </div>

                <h3 className="home-service-title">Software Development</h3>
              </div>

              <p className="home-service-description">
               We transform ideas into scalable, high-performance software solutions through our expertise in web and mobile application development. Secure, user-centric products built for long-term growth.
              </p>
            </div>
            </div>

            {/* Service Card 3 */}
            <div className="home-service-card-wrapper"> 
            <div className="home-service-card">
              <div className="home-service-icon-wrapper">
                <div className="home-service-icon">
                  <img
                    src={
                      process.env.PUBLIC_URL + "/assets/icons/trans_icon_2.png"
                    }
                    alt="transicon1"
                    className="home-service-icon-img"
                  />
                </div>

                <h3 className="home-service-title">Talent Acquisition</h3>
              </div>

              <p className="home-service-description">
                Connect with top IT professionals through our expert talent
                acquisition services. We deliver carefully vetted talent
                tailored to your project requirements and aligned with your
                long-term business goals.
              </p>
            </div>
            </div>

            {/* Service Card 3 */}
            <div className="home-service-card-wrapper"> 
            <div className="home-service-card">
              <div className="home-service-icon-wrapper">
                <div className="home-service-icon">
                  <img
                    src={
                      process.env.PUBLIC_URL + "/assets/icons/trans_icon_3.png"
                    }
                    alt="transicon1"
                    className="home-service-icon-img"
                  />
                </div>

                <h3 className="home-service-title">Technology & Consulting</h3>
              </div>
              <p className="home-service-description">
                Entrust your projects to our experienced team, delivering
                high-quality technology and consulting solutions on time and
                within budget—without compromising on performance or innovation.
              </p>
            </div>
            </div>

            {/* Service Card 4 */}
            <div className="home-service-card-wrapper"> 
            <div className="home-service-card">
              <div className="home-service-icon-wrapper">
                <div className="home-service-icon">
                  <img
                    src={
                      process.env.PUBLIC_URL + "/assets/icons/trans_icon_4.png"
                    }
                    alt="transicon1"
                    className="home-service-icon-img"
                  />
                </div>

                <h3 className="home-service-title">Payroll Outsourcing Services</h3>
              </div>
              <p className="home-service-description">
                Our payroll outsourcing services deliver end-to-end payroll
                management with complete compliance and precision, reducing risk
                while improving operational efficiency.
              </p>
            </div>
            </div>
          </div>
        </div>
      </section>
      {/* PARTNER WITH US SECTION */}
      <section className="partner-section">
        <div className="partner-container">
          <h2 className="partner-title">Partner with Us</h2>

          <p className="partner-description">
            At Inypeople, we empower businesses to achieve their goals through
            fast and result-driven solutions. Our expertise and collaborative
            approach have earned us the trust of over 100+ clients worldwide.
          </p>

          <div className="partner-btn-center">
            <LetsTalkButton />
          </div>
        </div>
      </section>
    </>
  );
}